<template>
  <div class="makeout-container" v-loading="loading">
    <div class="card-block">
      <div class="card-block__title">费用信息</div>
      <div class="card-block-content">
        <div class="info-item" v-for="info in infoList" :key="info.label">
          <div class="info-item__label">{{info.label}}</div>
          <div class="info-item__value">{{info.value}}</div>
        </div>
      </div>
    </div>
    <div class="card-block">
      <div class="card-block__title">发票信息</div>
      <div class="card-block-content">
        <div class="info-item"
          :class="{'info-item__file': info.name === 'file', 'info-item__upload': info.name === 'file'}"
          v-for="info in invoiceList"
          :key="info.label">
          <div class="info-item__label"
            :class="{'uploadLabel': info.name === 'file' && pageType === 'makeout'}"
          >{{info.label}}</div>
          <template v-if="info.name !== 'file'">
            <div v-if="info.name === 'accessory_url'" class="info-item__value">
              <img style="cursor: pointer" class="info-item__img" :src="info.value" @click.stop="toggleFullImg(info.value, true)"/>
              <span class="info-item__value__btn" @click.stop="toggleFullImg(info.value, true)">预览</span>
              <span class="info-item__value__btn" @click.stop="downloadImg(info.value)">下载</span>
            </div>
            <div v-else class="info-item__value">{{info.value}}</div>
          </template>
          <template v-else-if="pageType === 'makeout'">
            <div class="info-item__value">
              <yjh-upload
                :url="baseAPI + '/invoice/do_add'"
                :stopUpload="true"
                :max="10"
                :fileType="['JPG', 'JPEG', 'PNG', 'BMP']"
                overSizeToast="上传文件大小不能超过10M"
                @beforeUpload="handleUpload"
              ></yjh-upload>
            </div>
          </template>
          <template v-else>
            <div class="info-item__value">
              <img style="cursor: pointer" :src="info.value" @click.stop="toggleFullImg(info.value, true)" alt="发票文件">
              <span class="info-item__value__btn" @click.stop="toggleFullImg(info.value, true)">预览</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="card-block">
      <div class="card-block__title">物流信息</div>
      <div class="card-block-content">
        <div class="info-item" :class="{'info-item__input': (info.type === 'input' && pageType === 'makeout') }"
          v-for="info in expressList"
          :key="info.label">
          <div class="info-item__label">{{info.label}}</div>
          <template v-if="pageType === 'makeout' && info.type === 'input'">
            <div class="info-item__value">
              <Input v-model="info.value" :placeholder="'请选择' + info.label" style="width: 210px"/>
            </div>
          </template>
          <template v-else>
            <div class="info-item__value">{{info.value}}</div>
          </template>
        </div>
        <div class="info-item info-item__btn">
          <div class="info-item__value">
            <template v-if="pageType === 'makeout'">
              <Button type="primary" @click.stop="setMarkout" :disabled="marketDisabled">标记已开</Button>
            </template>
            <template v-else>
              <Button type="primary" @click.stop="gotoList">返回列表</Button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <full-diag :isShow="showFullImg" @close="toggleFullImg(false)">
      <div class="full-img-content">
        <!-- <img :src="invoiceList[6] === undefined ? '' : invoiceList[6].value" alt=""> -->
        <img :src="imgUrl" alt="">
      </div>
    </full-diag>
  </div>
</template>
<script>
import fullDiag from '@/components/dialogs/fullDiag'
import yjhUpload from '@/components/yjhUpload'
import { invoiceFeeDetail, invoiceAdd } from '@/api/invoice'
import { formatText } from '@/utils/common'
import { downImg } from '@/utils/file'
export default {
  name: 'detail',
  components: { fullDiag, yjhUpload },
  data() {
    return {
      loading: false,
      infoList: [], // 费用信息
      invoiceList: [], // 发票信息
      expressList: [], // 物流信息
      file: null,
      showFullImg: false,
      marketDisabled: false, // 标记已开按钮的disable值
      imgUrl: ''
    }
  },
  computed: {
    pageType() {
      return this.$route.name
    },
    // 'ukey' 或者 'fee'
    invoiceType() {
      return this.$route.params.type
    },
    invoiceId() {
      return this.$route.params.id
    },
    pageTitle() { // 当前状态 是开发票 还是查看发票
      return this.$route.name === 'makeout' ? '开发票' : '查看发票'
    },
    baseAPI() {
      return process.env.VUE_APP_BASE_API
    }
  },
  mounted() {
    this.$store.dispatch('setPage', {
      title: this.pageTitle,
      type: ' '
    })
    this.getInfo()
  },
  methods: {
    // 获取信息
    getInfo() {
      this.loading = true
      let req = {}
      if (this.invoiceType === 'vip') {
        req = {
          order_no: this.invoiceId
        }
      } else {
        req = {
          id: this.invoiceId,
          view_type: this.$route.name === 'makeout' ? '2' : '1'
        }
      }
      invoiceFeeDetail(this.invoiceType, req).then(res => {
        this.loading = false
        const { code, result } = res
        if (code === 0) {
          this.dealWithRes(result)
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    dealWithRes(res) { // 将获取的数据按照不同方式展示
      if (this.$route.params.type === 'vip') {
        this.infoList = [
          { label: '订单编号', name: 'order_no', value: res.order_no },
          { label: '下单用户', name: 'cust_name', value: res.cust_name },
          { label: '服务内容', name: 'order_memo', value: res.order_memo },
          { label: '支付方式', name: 'pay_type', value: formatText(res.pay_type, ['', '线下转账', '支付宝']) }, // 1线下转账；2支付宝
          { label: '订单金额', name: 'order_money', value: res.order_money },
          { label: '下单时间', name: 'order_time', value: res.order_time },
          { label: '发票类型', name: 'tax_type', value: formatText(res.tax_type, ['', '增值税专票', '增值税普票']) } // 1增值税专票；2增值税普票
        ]
      } else if (this.$route.params.type === 'ukey') {
        this.infoList = [
          { label: '订单编号', name: 'orderNo', value: res.order_id },
          { label: '下单用户', name: 'orderUser', value: res.user_id },
          { label: '服务内容', name: 'service', value: res.order_content },
          { label: '支付方式', name: 'payType', value: formatText(res.buy_type, ['支付宝', '微信']) }, // 0 支付宝 1 微信
          { label: '订单金额', name: 'money', value: res.order_money },
          { label: '下单时间', name: 'orderDate', value: res.create_time },
          { label: '发票类型', name: 'invoiceType', value: formatText(res.bill_info, ['不开发票', '增值税普票', '增值税专票']) } // 0不开发票 1增值税普票 2增值税专票
        ]
      } else { // 手续费
        this.infoList = [
          { label: '财务流水单号', name: 'orderNo', value: res.account_num },
          { label: '流水单号', name: 'orderUser', value: res.statement_num },
          { label: '合同编号', name: 'service', value: res.sct_no },
          { label: '付款日期', name: 'payType', value: res.payment_date },
          { label: '付款方', name: 'money', value: res.payer },
          { label: '收款方', name: 'orderDate', value: res.receiver },
          { label: '手续费金额', name: 'invoiceType', value: res.money },
          { label: '类型', name: 'money', value: formatText(res.type, ['', '收款', '付款', '解冻', '冻结', '服务费']) }, // 1:收款 2付款 3解冻 4冻结 5 服务费
          { label: '状态', name: 'orderDate', value: '成功' } // 写死的成功
        ]
      }
      // 发票信息和收件人
      if (this.invoiceType === 'vip') {
        this.invoiceList = [
          { label: '名称', name: 'tax_name', value: res.tax_name },
          { label: '地址', name: 'tax_address', value: res.tax_address },
          { label: '电话', name: 'tax_tel', value: res.tax_tel },
          { label: '税号', name: 'tax_no', value: res.tax_no },
          { label: '开户行', name: 'tax_bank', value: res.tax_bank },
          { label: '账号', name: 'tax_bank_no', value: res.tax_bank_no },
          { label: '营业执照', name: 'accessory_url', value: res.accessory_url },
          { label: '发票文件', name: 'file', value: res.tax_file_path }
        ]
        this.expressList = [
          { label: '收件人', name: 'receive_name', value: res.receive_name },
          { label: '收件地址', name: 'receive_address', value: res.receive_address },
          { label: '联系电话', name: 'receive_tel', value: res.receive_tel },
          { label: '物流公司', name: 'tax_logistics_company', type: 'input', value: res.tax_logistics_company, error: '' },
          { label: '运单号', name: 'tax_bill_no', type: 'input', value: res.tax_bill_no, error: '' }
        ]
      } else {
        this.invoiceList = [
          { label: '名称', name: 'name', value: res.name },
          { label: '地址', name: 'address', value: res.address },
          { label: '电话', name: 'phone', value: res.tel },
          { label: '税号', name: 'taxNo', value: res.tax_number },
          { label: '开户行', name: 'bank', value: res.bank },
          { label: '账号', name: 'account', value: res.account_number },
          { label: '营业执照', name: 'accessory_url', value: res.accessory_url },
          { label: '发票文件', name: 'file', value: res.bill_image }
        ]
        if (this.invoiceType === 'ukey') {
          this.invoiceList.splice(6, 1)
        }
        this.expressList = [
          { label: '收件人', name: 'receiver', value: res.consignee_name },
          { label: '收件地址', name: 'expressAddr', value: res.consignee_address },
          { label: '联系电话', name: 'expressPhone', value: res.consignee_tel },
          { label: '物流公司', name: 'expressName', type: 'input', value: res.express_name, error: '' },
          { label: '运单号', name: 'expressNo', type: 'input', value: res.express_no, error: '' }
        ]
      }
    },
    // 选文件
    handleUpload(file) {
      this.file = file
    },
    // 标记已开
    setMarkout() {
      if (!this.file) {
        this.$Message.info('请上传发票文件！')
        return
      }
      var formData = new FormData()
      formData.append('file', this.file)
      if (this.invoiceType === 'vip') {
        formData.append('order_no', this.infoList[0].value)
        formData.append('tax_logistics_company', this.expressList[3].value)
        formData.append('tax_bill_no', this.expressList[4].value)
      } else {
        formData.append('express_name', this.expressList[3].value)
        formData.append('express_no', this.expressList[4].value)
        formData.append('id', this.invoiceId)
        formData.append('invoice_type', this.invoiceType === 'ukey' ? 1 : 2)
      }
      this.marketDisabled = true // 标记已开按钮暂时关闭
      invoiceAdd(this.invoiceType, formData).then(res => {
        this.marketDisabled = false
        if (res.code === 0) {
          this.$router.go(-1)
        } else {
          this.$Message.info('开发票失败！')
        }
      })
    },
    toggleFullImg(url, flag) {
      this.imgUrl = url
      this.showFullImg = flag
    },
    gotoList() {
      this.$router.push({ name: this.invoiceType + 'Invoice' })
    },
    downloadImg(url) {
      if (url === undefined || url === '') {
        this.$Message.info('图片地址出错')
        return
      }
      // url = url.replace('https', 'http')
      const urlName = url.split('/')
      const name = urlName[urlName.length - 1]
      // .split('.')[0]
      downImg(url, name)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";
.info-item__img {
  width: 210px;
  height: 130px;
  border: 1px solid #d9e2ef;
  padding: 4px;
}
.info-item__value__btn {
  color: $blue;
  margin: 8px 10px;
  display: inline-block;
  cursor: pointer;
}
</style>
<style lang="scss">
  @import "@/styles/card.scss";
  .makeout-container {
    margin: -20px 0;
    .uploadLabel {
      &::before {
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 12px;
        color: #ed4014;
      }
    }
  }
</style>
